import { toastManager, ToastProvider } from '@systemeio/components'
import type { ReactNode } from 'react'

interface ToastOptions {
  duration?: number
  onClose?: () => void
}

type ToastType = 'error' | 'info' | 'success'

const getTimeout = (duration?: number) => {
  if (duration === Infinity) return 0

  return duration
}

const addToast = (type: ToastType, title: ReactNode, options?: ToastOptions) =>
  toastManager.add({
    type,
    title,
    timeout: getTimeout(options?.duration),
    onClose: options?.onClose,
  })

const toast = {
  dismiss: (id?: string) => toastManager.close(id),
  error: (title: ReactNode, options?: ToastOptions) => addToast('error', title, options),
  info: (title: ReactNode, options?: ToastOptions) => addToast('info', title, options),
  success: (title: ReactNode, options?: ToastOptions) => addToast('success', title, options),
}

export { toast, ToastProvider }
export type { ToastOptions }
